import moment from "moment";
import React, { Component } from "react";
import { Row, Col, Button, Drawer, Card, Tooltip, Icon, Tag, Table, Form } from "antd";
import { connect } from "react-redux";
import Request from '../../request';
import {
    FaUsers,
    FaUserTag,
    FaUserPlus,
    FaUserEdit,
    FaRegCalendarAlt,
    FaCalendarPlus,
    FaTasks,
    FaUser,
    FaMobileAlt,
    FaPhoneVolume
} from 'react-icons/fa';
import ListDrawer from './list';
import Autosuggest from 'react-autosuggest';
import LatestFollowUp from "../../components/_utils/latestFollowup";
import AppointmentDetails from "./appointmentDetails";
import TaskDetails from "./taskDetails";
import './css/frontOfficeDashboard.css';
import AddCallRegisterDetails from "../callRegister/addCallRegisterDetails";
import CallRegisterDetails from "./callRegisterDetails";
import AddAppointmentDrawer from "../../components/drawers/addAppointmentDrawer";



class NotCollectedPhone extends Component {
    state = {
        visible: true,
        data: []
    }

    onClose = () => {
        this.setState({ visible: false });
        setTimeout(() => {
            this.props.onClose();
        }, 300);
    }

    componentDidMount() {
        let { data } = this.props;
        this.setState({ data });
    }

    render() {
        let { visible, data } = this.state;

        const columns = [
            {
                title: "Employee & Status",
                key: "employee",
                width: "35%",
                render: (text, record) => {
                    const name = record.userId && record.userId.name ? record.userId.name : "Unknown Employee";
                    return (
                        <div style={{ padding: '5px 0' }}>
                            <div style={{ fontWeight: 600, color: "#1a3353", fontSize: '14px', marginBottom: '4px' }}>
                                {name}
                            </div>
                            <div style={{ fontSize: '12px', color: "#3b82f6", display: 'flex', alignItems: 'center' }}>
                                <Icon type="mobile" style={{ marginRight: 6 }} />
                                Pending Collection
                            </div>
                        </div>
                    );
                },
            },
            {
                title: "Submission Details",
                key: "reason",
                width: "40%",
                render: (text, record) => (
                    <div>
                        <div style={{ marginBottom: '4px', display: 'flex', alignItems: 'flex-start' }}>
                            <Icon type="file-text" style={{ marginRight: 8, color: '#4f46e5', marginTop: 3 }} />
                            <span style={{ fontWeight: 500, color: '#2d3436' }}>
                                {record.notSubmitReason || "No reason provided"}
                            </span>
                        </div>
                        <div style={{ fontSize: '11px', color: '#999', paddingLeft: '22px' }}>
                            Requirement: Phone Submission
                        </div>
                    </div>
                ),
            },
            {
                title: "Priority",
                key: "priority",
                align: 'center',
                render: () => (
                    <Tag style={{
                        backgroundColor: "#fff1f0",
                        color: "#cf1322",
                        border: "1px solid #ffa39e",
                        borderRadius: '4px',
                        fontWeight: 600
                    }}>
                        HIGH
                    </Tag>
                ),
            },
            {
                title: "Status",
                key: "status",
                align: 'right',
                render: () => (
                    <Tag color="orange" style={{ borderRadius: '12px', padding: '0 12px' }}>
                        Pending
                    </Tag>
                ),
            },
        ];

        return (
            <Drawer
                title={
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '95%' }}>
                        <span>
                            <Icon type="warning" style={{ marginRight: 10, color: '#3b82f6' }} />
                            Staff Personal Phones
                        </span>
                        <Tag
                            style={{
                                backgroundColor: '#3b82f6',
                                color: '#fff',
                                fontWeight: 700,
                                border: 'none',
                                borderRadius: '4px'
                            }}
                        >
                            {data.length} PENDING
                        </Tag>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                visible={visible}
                width={1000}
                className="modern-drawer-task"
            >
                <Table
                    dataSource={data}
                    columns={columns}
                    pagination={{
                        showSizeChanger: true,
                        defaultPageSize: 10,
                        pageSizeOptions: ["10", "20", "50"],
                    }}
                    rowKey={(record, index) => index}
                    style={{ background: '#fff' }}
                />
            </Drawer>
        );
    }
}

class AbsentEmployees extends Component {
    state = {
        visible: true,
        data: []
    }

    onClose = () => {
        this.setState({ visible: false })
        setTimeout(() => {
            this.props.onClose();
        }, 300)
    }

    componentDidMount() {
        let { data } = this.props
        this.setState({ data })
    }

    render() {
        let { visible, data } = this.state;

        const columns = [
            {
                title: 'Sr. No',
                key: 'serialNumber',
                width: 80,
                align: 'center',
                render: (text, record, index) => (
                    <div style={{ color: '#94a3b8', fontWeight: 500 }}>{index + 1}</div>
                )
            },
            {
                title: "Employee Details",
                key: "employeeDetails",
                render: (text, record) => (
                    <div style={{ padding: '5px 0' }}>
                        <div style={{ fontWeight: 600, color: "#1a3353", fontSize: '14px' }}>
                            {record.name}
                        </div>
                        <div style={{ fontSize: '11px', color: "#ef4444", marginTop: '2px', fontWeight: 500 }}>
                            <Icon type="warning" style={{ marginRight: 4 }} />
                            ABSENT TODAY
                        </div>
                    </div>
                )
            },
            {
                title: "Contact Information",
                key: "contact",
                render: (text, record) => (
                    <div>
                        <div style={{ marginBottom: '4px', color: '#434343', fontWeight: 500 }}>
                            <Icon type="phone" style={{ marginRight: 8, color: '#64748b' }} />
                            {record.contactNo || "N/A"}
                        </div>
                        <div style={{ fontSize: '12px', color: '#64748b' }}>
                            <Icon type="mail" style={{ marginRight: 8, fontSize: '11px' }} />
                            {record.email || "No Email"}
                        </div>
                    </div>
                )
            },
            {
                title: "Action",
                key: "action",
                align: 'right',
                render: (text, record) => (
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                        <Tag
                            color="red"
                            style={{ cursor: 'pointer', borderRadius: '4px', border: '1px solid #fca5a5' }}
                            onClick={() => window.open(`tel:${record.contactNo}`)}
                        >
                            <Icon type="mobile" style={{ marginRight: 4 }} /> CALL
                        </Tag>
                    </div>
                )
            }
        ];

        return (
            <Drawer
                title={
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '95%' }}>
                        <span>
                            <Icon type="user-delete" style={{ marginRight: 10, color: '#ef4444' }} />
                            Absent Employees
                        </span>
                        <Tag
                            className="bg-red"
                            style={{
                                border: '1px solid #ef4444',
                                borderRadius: '4px',
                                fontWeight: 700,
                                padding: '0 12px'
                            }}
                        >
                            {data.length} ON LEAVE
                        </Tag>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                visible={visible}
                width={850}
                className="modern-drawer-task"
            >
                <Table
                    columns={columns}
                    dataSource={data}
                    rowKey={(record, index) => index}
                    pagination={{
                        showSizeChanger: true,
                        defaultPageSize: 10,
                        pageSizeOptions: ['10', '20', '50']
                    }}
                    style={{ background: '#fff' }}
                />
            </Drawer>
        )
    }
}

// class PresentEmployees extends Component {
//     state = {
//         visible: true,
//         data: []
//     }

//     onClose = () => {
//         this.setState({ visible: false })
//         setTimeout(() => {
//             this.props.onClose();
//         }, 500)
//     }

//     constructor(props) {
//         super(props);
//         this.table = React.createRef();
//     }

//     componentDidMount() {
//         let { data } = this.props
//         this.setState({ data })
//     }

//     render() {
//         let { visible, data } = this.state;
//         let columns = [
//             {
//                 title: 'Sr. No',
//                 key: 'serialNumber',
//                 render: (text, record, index) => (
//                     <div>{index + 1}</div>
//                 )
//             },
//             {
//                 title: 'Employee Name',
//                 key: 'userId.name',
//             },
//             {
//                 title: 'Login At',
//                 key: 'loginAt',
//                 render: (text, record) => (
//                     record.loginAt ? moment(record.loginAt, 'HH:mm:ss').format('h:mm A') : null
//                 )
//             },
//             {
//                 title: 'Logout At',
//                 key: 'logoutAt',
//                 render: (text, record) => (
//                     record.logoutAt && record.logoutAt !== "NA" ? moment(record.logoutAt, 'HH:mm:ss').format('h:mm A') : null
//                 )
//             }
//         ];
//         return (
//             <Drawer
//                 title={`Present Employees:- ${data.length}`}
//                 placement="right"
//                 closable={true}
//                 onClose={this.onClose}
//                 visible={visible}
//                 width={800}>
//                 <Card bordered={true}>
//                     <TableComp
//                         ref={this.table}
//                         columns={columns}
//                         dataSource={data}
//                         // extraProps={{ scroll: { x: 900 } }}
//                         pagination={{
//                             showSizeChanger: true,
//                             defaultPageSize: 20,
//                             pageSizeOptions: ['10', '20', '50', '100', '1000']
//                         }}
//                     />
//                 </Card>
//             </Drawer>
//         )
//     }
// }

// class VisitorVisaLeads extends Component {
//     state = {
//         visible: true,
//         data: []
//     }

//     onClose = () => {
//         this.setState({ visible: false })
//         setTimeout(() => {
//             this.props.onClose();
//         }, 500)
//     }

//     constructor(props) {
//         super(props);
//         this.table = React.createRef();
//     }

//     componentDidMount() {
//         let { data } = this.props
//         this.setState({ data })
//     }

//     render() {
//         let { visible, data } = this.state;
//         const columns = [
//             {
//                 title: "ID",
//                 key: "id",
//                 dataIndex: "id",
//             },
//             {
//                 title: "Applicant Name",
//                 key: "applicantName",
//                 dataIndex: "applicantName",

//             },
//             {
//                 title: "Counsellor",
//                 key: "counsellorName",
//                 dataIndex: "counsellorId.name",
//             },
//             {
//                 title: "Conact",
//                 key: "mobwap",
//                 dataIndex: "mobwap",
//                 render: (val, record) => {
//                     return (
//                         <div>{record.countryCode ? `${record.countryCode}-` : null}{record.mobileNumber ? record.mobileNumber : ""}</div>
//                     )
//                 },
//             },
//             {
//                 title: "Follow Up",
//                 key: "followUp",
//                 dataIndex: "followUp",
//                 render: (text, record) => {
//                     return <LatestFollowUp info={text} />;
//                 },
//             },
//             {
//                 title: "Source",
//                 key: "source",
//                 dataIndex: "source"
//             },
//             {
//                 title: "Last Updated By",
//                 key: "updatedByUser",
//                 dataIndex: "updatedByUser",
//                 render: (text, record) => {
//                     return (
//                         <div>
//                             <div className={common.user}>
//                                 {record.updatedByUser
//                                     ? record.updatedByUser.name
//                                     : record.createdByUser
//                                         ? record.createdByUser.name
//                                         : ""}
//                             </div>
//                             <small>{text ? moment(text.time).format("lll") : ""}</small>
//                         </div>
//                     );
//                 },
//             },
//         ];
//         return (
//             <Drawer
//                 title={`Visitor Visa Leads:- ${data.length}`}
//                 placement="right"
//                 closable={true}
//                 onClose={this.onClose}
//                 visible={visible}
//                 width={800}>
//                 <Card bordered={true}>
//                     <TableComp
//                         ref={this.table}
//                         columns={columns}
//                         dataSource={data}
//                         // extraProps={{ scroll: { x: 900 } }}
//                         pagination={{
//                             showSizeChanger: true,
//                             defaultPageSize: 20,
//                             pageSizeOptions: ['10', '20', '50', '100', '1000']
//                         }}
//                     />
//                 </Card>
//             </Drawer>
//         )
//     }
// }



class VisitorVisaLeads extends Component {
    state = {
        visible: true,
        data: []
    }

    onClose = () => {
        this.setState({ visible: false })
        setTimeout(() => {
            this.props.onClose();
        }, 300)
    }

    componentDidMount() {
        let { data } = this.props
        this.setState({ data })
    }

    render() {
        let { visible, data } = this.state;

        const columns = [
            {
                title: "Lead Details",
                key: "leadDetails",
                width: "25%",
                render: (text, record) => (
                    <div style={{ padding: '5px 0' }}>
                        <div style={{ fontWeight: 600, color: "#1a3353", fontSize: '14px' }}>
                            {record.applicantName}
                        </div>
                        <div style={{ fontSize: '11px', color: "#778ca2", marginTop: '2px' }}>
                            ID: {record.id}
                        </div>
                    </div>
                )
            },
            {
                title: "Contact Info",
                key: "contact",
                render: (text, record) => (
                    <div>
                        <div style={{ marginBottom: '4px', color: '#1890ff', fontWeight: 500 }}>
                            <Icon type="phone" style={{ marginRight: 8 }} />
                            {record.countryCode ? record.countryCode + "-" : ""}{record.mobileNumber || "N/A"}
                        </div>
                        <div style={{ fontSize: '12px', color: '#64748b' }}>
                            <Icon type="environment" style={{ marginRight: 8, fontSize: '10px' }} />
                            Source: {record.source || "Direct"}
                        </div>
                    </div>
                )
            },
            {
                title: "Counsellor",
                key: "counsellorName",
                // Handled nested data index manually for safety
                render: (text, record) => {
                    const counsellor = record.counsellorId && record.counsellorId.name ? record.counsellorId.name : "Unassigned";
                    return (
                        <span>
                            <Icon type="user" style={{ marginRight: 8, color: '#4f46e5' }} />
                            {counsellor}
                        </span>
                    );
                }
            },
            {
                title: "Latest Follow Up",
                key: "followUp",
                width: "30%",
                render: (text, record) => (
                    <div style={{ background: '#f8fafc', padding: '8px', borderRadius: '6px', border: '1px solid #e2e8f0' }}>
                        <LatestFollowUp info={record.followUp} />
                    </div>
                ),
            },
            {
                title: "Last Activity",
                key: "updatedByUser",
                align: 'right',
                render: (text, record) => {
                    // Traditional conditional checks instead of ?.
                    let user = "System";
                    let time = record.createdAt;

                    if (record.updatedByUser && record.updatedByUser.name) {
                        user = record.updatedByUser.name;
                        time = record.updatedByUser.time;
                    } else if (record.createdByUser && record.createdByUser.name) {
                        user = record.createdByUser.name;
                    }

                    return (
                        <div style={{ textAlign: 'right' }}>
                            <div style={{ fontWeight: 500, color: '#434343' }}>{user}</div>
                            <div style={{ fontSize: '11px', color: '#999' }}>
                                {time ? moment(time).format("lll") : ""}
                            </div>
                        </div>
                    );
                },
            },
        ];

        return (
            <Drawer
                title={
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '95%' }}>
                        <span>
                            <Icon type="global" style={{ marginRight: 10, color: '#1890ff' }} />
                            Visitor Visa Leads
                        </span>
                        <Tag style={{ backgroundColor: '#1890ff', color: '#fff', border: 'none', borderRadius: '4px', fontWeight: 700 }}>
                            {data.length} TOTAL
                        </Tag>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                visible={visible}
                width={1000}
                className="modern-drawer-task"
            >
                <Table
                    columns={columns}
                    dataSource={data}
                    rowKey={(record) => record.id}
                    pagination={{
                        showSizeChanger: true,
                        defaultPageSize: 10,
                        pageSizeOptions: ['10', '20', '50', '100']
                    }}
                    style={{ background: '#fff' }}
                />
            </Drawer>
        )
    }
}



class FrontOfficeDashboard extends Component {
    _isMounted = false;

    constructor(props) {
        super(props);
        this.state = {
            value: '',
            searchField: '',
            drawer: false,
            showAppointmentDrawar: false,
            showVisitedStudentForm: false,
            showAbsenteesDrawer: false,
            showPresentEmployees: false,
            notCollectedPhones: {},
            notCollectedPhoneDrawer: false,
            visitorVisaLeadsDrawer: false,
            drawerParam: {},
            leads: { total: 0, arr: [] },
            appointments: {},
            callDetails: {},
            absentEmployees: {},
            presentEmployees: {},
            tasks: { total: 0 },
            visiteds: { total: 0, arr: [] },
            visitorLeads: { total: 0, arr: [] },
            suggestions: [],
            studentDetail: {},
            showAppointmentDrawar: false,
            showTaskDrawer: false,
            callRegisterDrawer: false,
            showAddCallRegister: false,
            showAddAppointment: false,
        };
    }

    async componentDidMount() {
        this._isMounted = true;
        await this.loadAllApis();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentWillReceiveProps(nextProps) {
        const { timer } = this.props;
        if (nextProps.timer !== timer) this.loadAllApis();
    }

    loadAllApis = async () => {
        try {
            let response = await Request.getFrontOfficeData({ deleted: false });
            if (this._isMounted && response) this.setState({ ...response });
        } catch (err) {
            console.error('Error loading front office data:', err);
        }
    }

    onSuggestionsFetchRequested = async ({ value }) => {
        try {
            let response = await Request.handleSearchStudent({
                // searchField: this.state.searchField || '',
                searchField: value || this.state.searchField || '',
                results: 300
            });
            let suggestions = [];
            if (response.data) {
                suggestions = response.data.map(student => ({
                    id: student._id,
                    text: `${student.id || ''} - ${student.studentName || ''} - ${student.dateOfBirth ? moment(student.dateOfBirth).format('ll') : ''}`
                }));
            }
            if (this._isMounted) this.setState({ suggestions });
        } catch (err) {
            console.error('Error fetching suggestions:', err);
        }
    }

    onSuggestionsClearRequested = () => {
        if (this._isMounted) this.setState({ suggestions: [] });
    }

    onSuggestionSelected = async (event, { suggestion }) => {
        try {
            if (!suggestion || !suggestion.id) return;
            let studentId = suggestion.id;
            let response = await Request.getStudentDetails(studentId);
            if (this._isMounted && response) {
                this.setState({ studentDetail: response.doc });
                this.loadAllApis();
            }
        } catch (err) {
            console.error('Error fetching student details:', err);
        }
    }

    onChange = (e, { newValue }) => {
        if (!this._isMounted) return;
        const value = newValue ? newValue.toString() : '';
        this.setState({ value, searchField: value });
    }

    getSuggestionValue = (suggestion) => {
        return suggestion.text || '';
    }

    renderSuggestion = (suggestion) => <span>{suggestion.text || ''}</span>;

    closeAbsentDrawer = () => this.setState({ showAbsenteesDrawer: false });
    closePresentDrawer = () => this.setState({ showPresentEmployees: false });
    closeNotCollectedDrawer = () => this.setState({ notCollectedPhoneDrawer: false });

    closeAddCallRegister = () => this.setState({ showAddCallRegister: false }, () => {
        this.loadAllApis();
    });

    closeAddAppointment = () => {
        this.setState({ showAddAppointment: false }, () => {
            this.loadAllApis();
        })
    }

    render() {
        const {
            drawer, drawerParam, visitorVisaLeadsDrawer, notCollectedPhones, notCollectedPhoneDrawer,
            leads, tasks, visiteds, appointments, absentEmployees, presentEmployees, showVisitedStudentForm,
            studentDetail, showAppointmentDrawar, visitorLeads, showTaskDrawer, showPresentEmployees, showAbsenteesDrawer,
            showAddCallRegister, callDetails, callRegisterDrawer, showAddAppointment
        } = this.state;

        const inputProps = {
            placeholder: 'Search Student by Name, DOB, Mobile, Email ID, UCI',
            value: this.state.value || '',
            onChange: this.onChange
        };


        return (
            <div className='fod-container'>
                {drawer && <ListDrawer param={drawerParam} onClose={() => this.setState({ drawer: false })} />}
                {
                    showAppointmentDrawar ?
                        <AppointmentDetails appointments={appointments} onClose={() => this.setState({ showAppointmentDrawar: false })} />
                        : null
                }
                {
                    callRegisterDrawer ?
                        <CallRegisterDetails drawerParam={drawerParam} onClose={() => this.setState({ callRegisterDrawer: false })} />
                        : null
                }
                {
                    showTaskDrawer ?
                        <TaskDetails tasks={tasks} onClose={() => this.setState({ showTaskDrawer: false })} />
                        : null
                }
                {
                    showAddAppointment ?
                        <AddAppointmentDrawer onClose={this.closeAddAppointment} />
                        : null
                }
                {/* Drawers */}
                {/* {showPresentEmployees && presentEmployees.data && <PresentEmployees data={presentEmployees.data} onClose={this.closePresentDrawer} />} */}
                {showAbsenteesDrawer && absentEmployees.data && <AbsentEmployees data={absentEmployees.data} onClose={this.closeAbsentDrawer} />}
                {notCollectedPhoneDrawer && notCollectedPhones.data && <NotCollectedPhone data={notCollectedPhones.data} onClose={this.closeNotCollectedDrawer} />}
                {visitorVisaLeadsDrawer && visitorLeads.data && <VisitorVisaLeads data={visitorLeads.data} onClose={() => this.setState({ visitorVisaLeadsDrawer: false })} />}
                {showAddCallRegister ?
                    <AddCallRegisterDetails onClose={this.closeAddCallRegister} />

                    : null}
                {/* TOP ROW - Stat Cards */}
                <Row className="fod-row">
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-blue">
                                <FaUsers />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Today's Leads</div>
                                <div className="stat-value">
                                    <span className="info-box-number">
                                        <a onClick={() => this.setState({ drawer: true, drawerParam: { title: `Today's Leads`, arr: leads.arr, count: leads.total, bgColorClass: "bg-blue", icon: <FaUsers /> } })}>{leads.total}</a>
                                        <span style={{ float: 'right' }}>
                                            <Button className='btn-transparent bg-blue'>
                                                <a href="/inquiry/add" target='_blank' rel="noreferrer"><FaUserPlus /></a>
                                            </Button>
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Col>
                    {/* <Col span={6}>
                        <div className="info-box glass">
                            <span className="info-box-icon bg-color-1 elevation-1"><FaUsers /></span>
                            <div className="info-box-content">
                                <span className="info-box-text">Today's Leads</span>
                                <span className="info-box-number">
                                    <a onClick={() => this.setState({ drawer: true, drawerParam: { title: `Today's Leads`, arr: leads.arr, count: leads.total } })}>{leads.total}</a>
                                    <span style={{ float: 'right' }}>
                                        <Button className='btn-transparent bg-color-1'>
                                            <a href="/inquiry/add" target='_blank' rel="noreferrer"><FaUserPlus /></a>
                                        </Button>
                                    </span>
                                </span>
                            </div>
                        </div>
                    </Col> */}
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-green">
                                <FaUserTag />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Today's Walk In</div>
                                <div className="stat-value">
                                    <span className="info-box-number">
                                        <a onClick={() => this.setState({ drawer: true, drawerParam: { title: `Today's Visited`, arr: visiteds.arr, count: visiteds.total, bgColorClass: "bg-green", icon: <FaUserTag /> } })}>{visiteds.total}</a>
                                        <span style={{ float: 'right' }}>
                                            <Button onClick={() => this.setState({ showVisitedStudentForm: true })} className='btn-transparent bg-green'><FaUserEdit /></Button>
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Col>
                    {/* <Col span={6}>
                        <div className="info-box glass">
                            <span className="info-box-icon bg-color-2 elevation-1"><FaUserTag /></span>
                            <div className="info-box-content">
                                <span className="info-box-text">Today's Walk In</span>
                                <span className="info-box-number">
                                    <a onClick={() => this.setState({ drawer: true, drawerParam: { title: `Today's Visited`, arr: visiteds.arr, count: visiteds.total } })}>{visiteds.total}</a>
                                    <span style={{ float: 'right' }}>
                                        <Button onClick={() => this.setState({ showVisitedStudentForm: true })} className='btn-transparent bg-color-2'><FaUserEdit /></Button>
                                    </span>
                                </span>
                            </div>
                        </div>
                    </Col> */}
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-tasks">
                                <Icon type="global" />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Today's Visitor Visa</div>
                                <div className="stat-value">
                                    <span className="info-box-number">
                                        <a onClick={() => this.setState({ visitorVisaLeadsDrawer: true })}>{visitorLeads.total}</a>
                                        <span style={{ float: 'right' }}>

                                            <Button className='btn-transparent bg-tasks'>
                                                <a href="/visaEnquiry/add" target='_blank' rel="noreferrer"><FaUserPlus /></a>
                                            </Button>
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Col>
                    {/* <Col span={6}>
                        <div className="info-box glass">
                            <span className="info-box-icon bg-color-3 elevation-1"><FaUsers /></span>
                            <div className="info-box-content">
                                <span className="info-box-text">Today's Visitor Visa</span>
                                <span className="info-box-number">
                                    <a onClick={() => this.setState({ visitorVisaLeadsDrawer: true })}>{visitorLeads.total}</a>
                                    <span style={{ float: 'right' }}>
                                        <Button className='btn-transparent bg-color-3'>
                                            <a href="/visaEnquiry/add" target='_blank' rel="noreferrer"><FaUserPlus /></a>
                                        </Button>
                                    </span>
                                </span>
                            </div>
                        </div>
                    </Col> */}
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-appointments">
                                <FaRegCalendarAlt />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Today's Appointments</div>
                                <div className="stat-value">
                                    <span className="info-box-number">
                                        <a onClick={() => this.setState({ showAppointmentDrawar: true })}>{appointments.total}</a>
                                        <span style={{ float: 'right' }}>
                                            <Button className='btn-transparent bg-appointments' onClick={() => this.setState({ showAddAppointment: true })}>
                                                <FaCalendarPlus />
                                            </Button>
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Col>

                    {/* <Col span={6}>
                        <div className="info-box glass">
                            <span className="info-box-icon bg-color-4 elevation-1"><FaRegCalendarAlt /></span>
                            <div className="info-box-content">
                                <span className="info-box-text">Today's Appointments</span>
                                <span className="info-box-number">
                                    <a onClick={() => this.setState({ showAppointmentDrawar: true })}>{appointments.total}</a>
                                    <span style={{ float: 'right' }}>
                                        <Button className='btn-transparent bg-color-4'>
                                            <a href='/appointment' target='_blank' rel="noreferrer"><FaCalendarPlus /></a>
                                        </Button>
                                    </span>
                                </span>
                            </div>
                        </div>
                    </Col> */}
                    <Col span={6}>
                        <div className="stat-card">
                            {/* Modern Blue Theme for Active Incoming Logic */}
                            <div className="stat-icon-wrapper bg-blue">
                                <FaPhoneVolume />
                            </div>

                            <div className="stat-data">
                                <div className="stat-label">Today's Incoming Calls</div>
                                <div className="stat-value">
                                    <span className="info-box-number">
                                        {/* Main Link for Drawer */}
                                        <a

                                            onClick={() => this.setState({
                                                callRegisterDrawer: true, drawerParam: {
                                                    title: "Today's Incoming Calls",
                                                    data: callDetails.data,
                                                    count: callDetails.total,
                                                    bgColorClass: 'bg-blue',
                                                    icon: <FaPhoneVolume />
                                                }
                                            })}
                                        >
                                            {callDetails.total}
                                        </a>

                                        {/* Quick Add Action styled more cleanly */}
                                        <span style={{ float: 'right' }}>
                                            <Tooltip title="Add New Call Record">
                                                <Button className='btn-transparent bg-blue' onClick={() => this.setState({
                                                    showAddCallRegister: true,
                                                })}>
                                                    <Icon type="plus" style={{ fontSize: '12px' }} />
                                                </Button>
                                            </Tooltip>
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-tasks">
                                <FaTasks />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Today's Tasks</div>
                                <div className="stat-value">
                                    <span className="info-box-number">
                                        <a onClick={() => this.setState({ showTaskDrawer: true })}>{tasks.total}</a>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Col>
                    {/* <Col span={6}>
                        <div className="info-box glass">
                            <span className="info-box-icon bg-color-3 elevation-1"><FaTasks /></span>
                            <div className="info-box-content">
                                <span className="info-box-text">Today's Tasks</span>
                                <span className="info-box-number">{tasks.total}</span>
                            </div>
                        </div>
                    </Col> */}
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-red">
                                <FaUser />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Absent Employees</div>
                                <div className="stat-value">
                                    <span className="info-box-number">
                                        <a onClick={() => this.setState({ showAbsenteesDrawer: true })}>{absentEmployees.total}</a>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Col>
                    {/* <Col span={6}>
                        <div className="info-box glass">
                            <span className="info-box-icon bg-color-3 elevation-1"><FaUser /></span>
                            <div className="info-box-content">
                                <span className="info-box-text">Absent Employees</span>
                                <span className="info-box-number">
                                    <a onClick={() => this.setState({ showAbsenteesDrawer: true })}>{absentEmployees.total}</a>
                                </span>
                            </div>
                        </div>
                    </Col> */}

                    {/* <Col span={6}>
                        <div className="info-box glass">
                            <span className="info-box-icon bg-color-2 elevation-1"><FaUser /></span>
                            <div className="info-box-content">
                                <span className="info-box-text">Present Employees</span>
                                <span className="info-box-number">
                                    <a onClick={() => this.setState({ showPresentEmployees: true })}>{presentEmployees.total}</a>
                                </span>
                            </div>
                        </div>
                    </Col> */}
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-blue">
                                <FaMobileAlt />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Staff Personal Phones</div>
                                <div className="stat-value">
                                    <span className="info-box-number">
                                        <a onClick={() => this.setState({ notCollectedPhoneDrawer: true })}>{notCollectedPhones.total}</a>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Col>
                    {/* <Col span={6}>
                        <div className="info-box glass">
                            <span className="info-box-icon bg-color-1 elevation-1"><FaMobileAlt /></span>
                            <div className="info-box-content">
                                <span className="info-box-text">Not Collected Phones</span>
                                <span className="info-box-number">
                                    <a onClick={() => this.setState({ notCollectedPhoneDrawer: true })}>{notCollectedPhones.total}</a>
                                </span>
                            </div>
                        </div>
                    </Col> */}
                </Row>

                {/* Appointments Panel */}
                {showAppointmentDrawar && appointments.total > 0 && appointments.data && (
                    <div className="glass-panel">
                        <h2 className="panel-title">{`Appointments : ${appointments.total}`}</h2>
                        <table className="student-custom-table" cellPadding={10}>
                            <thead>
                                <tr>
                                    <th>Appointment Id</th>
                                    <th>Subject</th>
                                    <th>Type</th>
                                    <th>Name</th>
                                    <th>Date/Time</th>
                                    <th>Attendees</th>
                                    <th>Created By</th>
                                </tr>
                            </thead>
                            <tbody>
                                {appointments.data.map((a, i) => (
                                    <tr key={i}>
                                        <td>{a.appId}</td>
                                        <td>{a.subject}</td>
                                        <td>{a.fromType}</td>
                                        <td>{a.name}</td>
                                        <td>{moment(a.startDate).format('DD-MMM-YYYY')}<br />{a.startTime}</td>
                                        <td>{a.attendees && a.attendees.length > 0 ? a.attendees.join(', ') : ''}</td>
                                        <td>{a.name}<br /><small>{moment(a.time).format('lll')}</small></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}

                {/* Student Search Panel */}
                {showVisitedStudentForm && (
                    <div className="glass-panel main-search-container">
                        <div className="panel-header-section">
                            <h2 className="panel-title">
                                <Icon type="search" className="title-icon" /> Search Student
                            </h2>
                            <div className="search-instruction">Type student name or Vision ID to begin</div>
                        </div>

                        <div className="autosuggest-wrapper-modern">
                            <Autosuggest
                                suggestions={this.state.suggestions}
                                onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                                onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                                onSuggestionSelected={this.onSuggestionSelected}
                                getSuggestionValue={this.getSuggestionValue}
                                renderSuggestion={this.renderSuggestion}
                                inputProps={inputProps}
                            />
                        </div>

                        {studentDetail && studentDetail.id && (
                            <div className="student-info-grid-card">
                                <div className="card-accent-bar"></div>

                                <div className="student-card-header">
                                    <div className="student-avatar-circle">
                                        {studentDetail.studentName ? studentDetail.studentName.charAt(0).toUpperCase() : 'S'}
                                    </div>
                                    <div className="student-main-meta">
                                        <h3>{studentDetail.studentName}</h3>
                                        <Tag color="blue" className="vision-id-tag">ID: {studentDetail.id}</Tag>
                                    </div>
                                </div>

                                <div className="info-grid">
                                    {/* Column 1 */}
                                    <div className="info-item">
                                        <Icon type="calendar" className="info-icon" />
                                        <div className="info-content">
                                            <label>Date of Birth</label>
                                            <span>{moment(studentDetail.dateOfBirth).format('ll')}</span>
                                        </div>
                                    </div>

                                    <div className="info-item">
                                        <Icon type="desktop" className="info-icon" />
                                        <div className="info-content">
                                            <label>Desk Level</label>
                                            <span>{studentDetail.atLevel || '-'}</span>
                                        </div>
                                    </div>

                                    {/* Column 2 */}
                                    <div className="info-item">
                                        <Icon type="global" className="info-icon" />
                                        <div className="info-content">
                                            <label>Study Mode</label>
                                            <span className="mode-text">{studentDetail.mode}</span>
                                        </div>
                                    </div>

                                    <div className="info-item">
                                        <Icon type="team" className="info-icon" />
                                        <div className="info-content">
                                            <label>Assigned Counsellor</label>
                                            <span>{studentDetail.counsellorId ? studentDetail.counsellorId.name : '-'}</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="branch-footer-info">
                                    <Icon type="environment" theme="filled" />
                                    <span>Branch Location: <strong>{studentDetail.studentBranchId ? studentDetail.studentBranchId.branchName : '-'}</strong></span>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>
        );
    }
}


const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}


export default connect(mapDispatchToProps)
    (FrontOfficeDashboard)